import type { ReactElement } from 'react';
import useStyles from './TextLogo.styles';

interface Props {
  color?: string;
  width?: string;
  classname?: string;
}

export default function TextLogo({
  width = '676',
  classname,
  color,
}: Props): ReactElement {
  const { classes: colorStyles, cx } = useStyles({ color });

  // biome-ignore lint/suspicious/noImplicitAnyLet: Automated migration to Biome
  let selectedClass;
  if (color) {
    selectedClass = cx(colorStyles.textLogo, classname);
  } else {
    selectedClass = classname;
  }

  return (
    // biome-ignore lint/a11y/noSvgWithoutTitle: Automated migration to Biome
    <svg
      aria-label='sunrun logo'
      className={selectedClass}
      data-testid='logo'
      width={width}
      viewBox='0 0 3573 676'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path d='M0 551.736L92.8358 462.64C129.406 512.346 206.306 553.596 301.021 553.596C377.921 553.596 432.307 526.403 432.307 470.138C432.307 327.595 6.53935 450.443 22.4946 198.17H23.4343C119.089 318.198 572.989 193.471 572.989 465.439C572.989 592.986 466.078 675.504 298.221 675.504C164.117 675.504 52.5258 624.858 0 551.717L0 551.736ZM298.221 0.320581C436.085 0.320581 518.603 43.4496 573.929 115.67L482.033 203.827C441.704 157.879 394.816 122.248 298.221 122.248C207.246 122.248 165.056 150.381 165.056 195.389C165.056 205.706 167.875 216.963 171.615 223.522V224.461C132.225 220.703 33.7515 204.767 33.7515 139.124C33.7515 73.4808 129.406 0.320581 298.221 0.320581ZM634.893 460.779V9.69813H773.677V446.703C773.677 509.527 800.87 553.615 865.573 553.615C934.974 553.615 1034.37 507.667 1122.53 424.209L1259.45 294.803H1260.39V537.698C1260.39 626.795 1206.92 675.562 1122.53 675.562V444.862C1018.43 606.16 941.533 675.562 828.063 675.562C704.275 675.562 634.874 598.662 634.874 460.799L634.893 460.779ZM1517.36 122.229C1447.96 122.229 1348.56 168.177 1260.41 251.635L1123.48 381.981H1122.54V138.146C1122.54 49.0493 1176.01 0.282227 1260.41 0.282227V230.981C1364.5 69.7221 1441.4 0.320581 1554.87 0.320581C1678.66 0.320581 1748.06 77.2203 1748.06 215.084V666.165H1609.28V229.14C1609.28 166.317 1582.08 122.229 1517.38 122.229H1517.36ZM1834.34 9.69813H2159.75C2296.68 9.69813 2393.27 59.4049 2393.27 169.116C2393.27 260.092 2321.07 326.675 2186.02 332.294V331.354C2223.53 312.599 2252.61 275.089 2252.61 225.382C2252.61 162.558 2207.6 126.908 2141.95 126.908H1973.16V666.146H1834.38V9.69813H1834.34ZM2006.89 360.426V359.487H2174.75C2344.48 359.487 2388.57 432.628 2388.57 525.483V666.146H2249.79V559.234C2249.79 453.262 2185.08 396.057 2006.89 360.426ZM2459.85 460.779V9.69813H2598.64V446.703C2598.64 509.527 2625.83 553.615 2690.53 553.615C2759.93 553.615 2859.33 507.667 2947.48 424.209L3084.41 294.803H3085.35V537.698C3085.35 626.795 3031.9 675.562 2947.48 675.562V444.862C2843.39 606.16 2766.49 675.562 2653.02 675.562C2529.23 675.562 2459.83 598.662 2459.83 460.799L2459.85 460.779ZM3342.32 122.229C3272.92 122.229 3173.52 168.177 3085.37 251.635L2948.44 381.981H2947.5V138.146C2947.5 49.0493 3000.95 0.282227 3085.37 0.282227V230.981C3189.44 69.7221 3266.34 0.320581 3379.81 0.320581C3503.6 0.320581 3573 77.2203 3573 215.084V666.165H3434.22V229.14C3434.22 166.317 3407.02 122.229 3342.32 122.229Z' />
    </svg>
  );
}
